import request from '@/http/request'
export const getPermissionList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/permission/list`, params)
}
export const getRoleSearch = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/role/search`, { params })
}
export const saveRole = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/role/add`, params, { hiddenError: true })
}
export const updateRole = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/role/update`, params, { hiddenError: true })
}
export const getRoleDetail = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/role/detail`, { params })
}

export const getRoleList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/role/list`, { params })
}

export const getRoleDetailList = params => {
  return request.get(
    `${process.env.REACT_APP_API_URL}/nfc/v1/api/role/detailList
  `,
    { params }
  )
}
